module.exports = __webpack_public_path__ + "images/kiacc2d630d79966cdd625c4a1222a446f2.png";